/**  DrmUtils.
 *   Utilities used by the Drm functionality
 */

/**
 * @access internal
 */
class DrmUtils {

	// converts string to Uint8Array (wide chars)
	// better not be used for complex characters sets!
	static stringToArray8(string) {
		let buffer = new ArrayBuffer(string.length);
		let array = new Uint8Array(buffer);
		for (let i = 0, strLen = string.length; i < strLen; i++) {
			array[i] = string.charCodeAt(i);
		}

		return array;
	}

	// converts string to Uint16Array (wide chars)
	static stringToArray16(string) {
		var buffer = new ArrayBuffer(string.length * 2); // 2 bytes for each char
		var array = new Uint16Array(buffer);
		for (var i = 0, strLen = string.length; i < strLen; i++) {
			array[i] = string.charCodeAt(i);
		}
		return array;
	}

	// converts a 16 or 8 bit array of wide characters to a string
	static wideArrayToString(array) {
		var uint16array = new Uint16Array(array.buffer);
		return String.fromCharCode.apply(null, uint16array);
	}

	// converts a 16 or 8 bit array to a string, does not cast to wide.
	static arrayToString(array) {
		var uint16array = new Uint16Array(array);
		return String.fromCharCode.apply(null, uint16array);
	}

	// wraps a naked playready license request as a PlayReadyObject with headers that the 3.2 era DRM expects (and MS platforms deliver)
	// used by Tizen etc
	static wrapPlayReadyChallengeAsPlayReadyObjectUcs16(data) {
		const playReadyObjectHeader = '<PlayReadyKeyMessage type="LicenseAcquisition"><LicenseAcquisition Version="1"><Challenge encoding="base64encoded">';
		const playReadyObjectFooter = '</Challenge><HttpHeaders><HttpHeader><name>Content-Type</name><value>text/xml; charset=utf-8</value></HttpHeader><HttpHeader><name>SOAPAction</name><value>"http://schemas.microsoft.com/DRM/2007/03/protocols/AcquireLicense"</value></HttpHeader></HttpHeaders></LicenseAcquisition></PlayReadyKeyMessage>';

		// data is Uint8Array of character bytes, as would be sent to the license server.

		// convert to string
		let dataString = String.fromCharCode.apply(null, data);

		// base64 encode
		let dataB64 = btoa(dataString);

		// wrap in PlayReadyObject header/footer
		let playReadyObjectString = playReadyObjectHeader + dataB64 + playReadyObjectFooter;

		// convert to UCS16
		let data16 = DrmUtils.stringToArray16(playReadyObjectString);

		// pack as Uint8Array
		let data8 = new Uint8Array(data16.buffer);

		return data8;
	}
}

export default DrmUtils;



// WEBPACK FOOTER //
// ./src/drm/DrmUtils.js